import { Formik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import Images from 'assets/img';
import Button from 'components/Button';
import Paper from 'components/Paper';
import TextField from 'components/TextField';
import ConvocationsActions from 'store/ducks/convocations';
import CtesActions from 'store/ducks/cte';
import ProvidersActions from 'store/ducks/providers';
import CteActions from 'store/ducks/cte';
import TruckerActions from 'store/ducks/trucker';
import { viagensAPI, clientesAPI, fornecedoresAPI, accountsPayableAPI, accountsReceivableAPI } from 'services/apiRest';
import TextInput from 'components/TextInput';
import { schema } from './schemaValidation';
import DeliveryPoint from './Sections/DeliveryPoint';
import LoadInfo from './Sections/LoadInfo';
import ProviderData from './Sections/ProviderData';
import CteMdfe from './Sections/CteMdfe';
import MunicipiosCarga from './Sections/MunicipiosCarga';
import ProdutoPredominante from './Sections/ProdutoPredominante';
import Rodoviario from './Sections/Rodoviario';
import Totais from './Sections/Totais';
import WrapperInput from 'components/WrapperInput';
import { useAlert } from 'react-alert';

import {
  Container,
  FieldLabel,
  Header,
  WrapperButtons,
  TabNav,
  TabItem,
  WrapperNav,
  WrapperSection,
} from './styles';
import Section from './components/Section';
import { addDays } from 'date-fns';
import Insurance from './Sections/Insurance';

// Componente wrapper para InputMask que preserva a posição do cursor (igual ao usado em ViagemForm)
const MaskedInput = ({ mask, value, onChange, onBlur, children, ...props }) => {
  const handleChange = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const oldValue = value || '';
    const newValue = input.value || '';

    onChange(e);

    setTimeout(() => {
      if (input && input.setSelectionRange) {
        const lengthDiff = newValue.length - oldValue.length;
        let newPosition = cursorPosition;

        if (lengthDiff > 0) {
          newPosition = Math.min(cursorPosition + lengthDiff, newValue.length);
        } else if (lengthDiff < 0) {
          newPosition = Math.max(0, cursorPosition + lengthDiff);
        }

        newPosition = Math.min(newPosition, newValue.length);
        input.setSelectionRange(newPosition, newPosition);
      }
    }, 0);
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <InputMask
      {...props}
      mask={mask}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      alwaysShowMask={false}
      maskChar={null}
    >
      {children}
    </InputMask>
  );
};

function PublicConvocation({ history, location }) {
  const dispatch = useDispatch();
  const alert = useAlert();

  const convocationId = location.state.convocationId;
  const provider = location.state.provider;
  const edit = location.state.edit;
  const view = location.state.view || false; // Modo somente leitura

  const [convocationType, setConvocationType] = useState('public');
  const { truckers } = useSelector((state) => state.trucker);
  const [headerId, setHeaderId] = React.useState(0);
  const [confirm, setConfirm] = useState(false);
  const { oneTrucker } = useSelector((state) => state.trucker);
  const { convocationActive } = useSelector((state) => state.convocations);
  const { cte } = useSelector((state) => state.cte);
  
  // Refs para evitar loops infinitos
  const cteTypeInitializedRef = useRef(false);
  const invoicesInitializedRef = useRef(false);
  const truckerInitializedRef = useRef(false);
  const formikRef = useRef(null);

  useEffect(() => {
    dispatch(ConvocationsActions.getConvocationsRequest());
    dispatch(ProvidersActions.getProvidersRequest());

    if (edit && convocationId?.id) {
      dispatch(CteActions.getCteRequest(convocationId.id));
    }
  }, [dispatch, edit, convocationId]);

  const { providers } = useSelector((state) => state.providers);


  // Carregar viagens relacionadas à carga quando estiver editando
  useEffect(() => {
    if (edit && convocationId?.id && formikRef.current) {
      viagensAPI.listar({ carga_id: convocationId.id })
        .then((viagens) => {
          if (viagens && viagens.length > 0 && formikRef.current) {
            const deliveryViagens = viagens.map((viagem) => ({
              id: viagem.id,
              referencia: viagem.referencia || '-',
              data_emissao: viagem.data_emissao || '-',
              valor: viagem.transporte?.valor_servico || viagem.transporte?.valor_carga || 0,
              invoices_count: viagem.invoices?.length || 0,
            }));
            formikRef.current.setFieldValue('delivery_viagens', deliveryViagens, false);
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar viagens da carga:', error);
        });
    }
  }, [edit, convocationId]);

  const handleChange = (_, value) => {
    setHeaderId(value);
  };

  // Função para obter valores iniciais
  const getInitialValues = () => ({
    cnpj: convocationId?.cnpj || '',
      owner: convocationId?.owner || '',
      owner_phone: convocationId?.owner_phone || '',
      owner_email: convocationId?.owner_email || '',
      note: convocationId?.note || '',
      validity: convocationId?.validity 
        ? (typeof convocationId.validity === 'string' 
            ? convocationId.validity.split('T')[0] 
            : convocationId.validity instanceof Date
              ? convocationId.validity.toISOString().split('T')[0]
              : new Date(convocationId.validity).toISOString().split('T')[0])
        : '',

      type_convocation: convocationId?.type_convocation || 'public',
      type_insurance: convocationId?.type_insurance || '',
      insurance_value: convocationId?.insurance_value || '0',
      selected_insurance_id: convocationId?.selected_insurance_id || '',
      insurance_codigo: convocationId?.insurance_codigo || '',
      insurance_nome_seguradora: convocationId?.insurance_nome_seguradora || '',
      insurance_cnpj_seguradora: convocationId?.insurance_cnpj_seguradora || '',
      insurance_numero_apolice: convocationId?.insurance_numero_apolice || '',
      insurance_responsavel: convocationId?.insurance_responsavel || '',
      insurance_cpf_cnpj_contratante: convocationId?.insurance_cpf_cnpj_contratante || '',
      payment_responser: convocationId?.payment_responser || '',
      private_trucker: convocationId?.driver_name || '',
      private_trucker_cpf: convocationId?.driver || '',
      collect_point: convocationId?.collect_point || '',
      collect_zipcode: convocationId?.collect_zipcode || '',
      collect_number: convocationId?.collect_number || '',
      collect_neighborhood: convocationId?.collect_neighborhood || '',
      collect_complement: convocationId?.collect_complement || '',
      collect_state: convocationId?.collect_state || '',
      collect_city: convocationId?.collect_city || '',
      collect_lat: convocationId?.collect_lat || '',
      collect_lng: convocationId?.collect_lng || '',
      collect_corresponding_name: convocationId?.collect_corresponding || '',
      collect_corresponding_phone:
        convocationId?.collect_corresponding_phone || '',
      collect_corresponding_email:
        convocationId?.collect_corresponding_email || '',
      toll_value: convocationId?.toll_value ?? '',
      cte_type: cte?.id && edit ? 'embarcador' : 'motorista',
      cte_key: '',
      delivery_cnpj: '',
      delivery_cpf: '',
      // Campos CT-e e MDF-e
      natureza_operacao: convocationId?.natureza_operacao || '',
      cfop: convocationId?.cfop || '',
      tipo_servico: convocationId?.tipo_servico || '0',
      modal: convocationId?.modal || '01',
      tipo_cte: convocationId?.tipo_cte || '0',
      uf_inicio: convocationId?.uf_inicio || '',
      uf_fim: convocationId?.uf_fim || '',
      data_inicio_viagem: convocationId?.data_inicio_viagem || '',
      codigo_municipio_carregamento: convocationId?.codigo_municipio_carregamento || '',
      nome_municipio_carregamento: convocationId?.nome_municipio_carregamento || '',
      uf_carregamento: convocationId?.uf_carregamento || '',
      codigo_municipio_descarregamento: convocationId?.codigo_municipio_descarregamento || '',
      nome_municipio_descarregamento: convocationId?.nome_municipio_descarregamento || '',
      uf_descarregamento: convocationId?.uf_descarregamento || '',
      outras_caracteristicas: convocationId?.outras_caracteristicas || '',
      // Campos Produto Predominante
      tipo_carga: convocationId?.tipo_carga || '',
      cargo_type: convocationId?.type || convocationId?.tipo_carga || '', // Mapear type/tipo_carga para cargo_type
      // Campos Rodoviário
      transport_type: convocationId?.transport_type || 'tac',
      rntrc: convocationId?.rntrc || '',
      ciot: convocationId?.ciot || '',
      veiculos: Array.isArray(convocationId?.veiculos) ? convocationId.veiculos : (convocationId?.veiculos ? Array.from(convocationId.veiculos) : []),
      condutores: Array.isArray(convocationId?.condutores) ? convocationId.condutores : (convocationId?.condutores ? Array.from(convocationId.condutores) : []),
      // Campos Totais
      quantidade_cte: convocationId?.quantidade_cte ?? '',
      quantidade_nfe: convocationId?.quantidade_nfe ?? '',
      quantidade_mdfe: convocationId?.quantidade_mdfe ?? '',
      valor_carga: convocationId?.valor_carga ?? '',
      peso_bruto: convocationId?.peso_bruto ?? '',
      peso_liquido: convocationId?.peso_liquido ?? '',
      value: convocationId?.value ?? '',
      freight_value: convocationId?.freight_value ?? '',
      adiantamento_motorista: convocationId?.adiantamento_motorista ?? '',
      naturezaAdiantamentoId: convocationId?.natureza_adiantamento_id || '',
      naturezaFreteId: convocationId?.natureza_frete_id || '',
      descricao_produto: convocationId?.descricao_produto || '',
      gtin: convocationId?.gtin || '',
      ncm: convocationId?.ncm || '',
      informacoes_fisco: convocationId?.informacoes_fisco || '',
      informacoes_complementares: convocationId?.informacoes_complementares || '',
      municipios_carga: Array.isArray(convocationId?.municipios_carga) ? convocationId.municipios_carga : (convocationId?.municipios_carga ? Array.from(convocationId.municipios_carga) : []),
      ufs_carga: Array.isArray(convocationId?.ufs_carga) ? convocationId.ufs_carga : (convocationId?.ufs_carga ? Array.from(convocationId.ufs_carga) : []),
      ufs_percurso: Array.isArray(convocationId?.ufs_percurso) ? convocationId.ufs_percurso : (convocationId?.ufs_percurso ? Array.from(convocationId.ufs_percurso) : []),
  
      invoices: cte?.id && edit ? (Array.isArray(cte?.invoices) ? cte.invoices : (cte?.invoices ? Array.from(cte.invoices) : [])) : [],
      delivery_viagens: [],
      provider_id: provider ? provider.id : (convocationId?.provider_id || ''),
    
  });

  // Função handleSubmit que será chamada pelo Formik
  const handleSubmit = (values) => {
    
    // Validar com schema
    schema()
      .validate(values, { abortEarly: false })
      .then(() => {
        handleSubmitted(values);
      })
      .catch((err) => {
        console.error('[CreateConvocation] Erros de validação do schema:', err);
        const validationErrors = {};
        const errorMessages = [];
        
        // Mapeamento de nomes de campos para nomes amigáveis
        const fieldNames = {
          owner: 'Solicitante',
          value: 'Frete Motorista',
          cargo_type: 'Tipo de carga',
          freight_value: 'Frete Embarcador',
          toll_value: 'Valor do Pedágio',
          private_trucker_cpf: 'CPF do motorista',
          insurance_value: 'Valor do seguro',
          descricao_produto: 'Descrição do produto',
          natureza_operacao: 'Natureza da operação',
          cfop: 'CFOP',
          tipo_servico: 'Tipo de serviço',
          modal: 'Modal',
          tipo_cte: 'Tipo de CT-e',
          uf_inicio: 'UF de início',
          uf_fim: 'UF de fim',
          data_inicio_viagem: 'Data de início da viagem',
          uf_carregamento: 'UF de carregamento',
          codigo_municipio_carregamento: 'Código do município de carregamento',
          nome_municipio_carregamento: 'Nome do município de carregamento',
          uf_descarregamento: 'UF de descarregamento',
          codigo_municipio_descarregamento: 'Código do município de descarregamento',
          nome_municipio_descarregamento: 'Nome do município de descarregamento',
          rntrc: 'RNTRC',
          delivery_viagens: 'Viagens selecionadas',
          quantidade_cte: 'Quantidade CT-e',
          quantidade_nfe: 'Quantidade NFe',
          quantidade_mdfe: 'Quantidade MDF-e',
          valor_carga: 'Valor da carga',
          peso_bruto: 'Peso bruto',
          peso_liquido: 'Peso líquido',
        };
        
        if (err.inner) {
          err.inner.forEach((error) => {
            if (error.path) {
              validationErrors[error.path] = error.message;
              const fieldName = fieldNames[error.path] || error.path;
              errorMessages.push(`• ${fieldName}: ${error.message}`);
            }
          });
        }
        
        if (formikRef.current) {
          formikRef.current.setErrors(validationErrors);
          // Marcar todos os campos com erro como touched para exibir as mensagens
          Object.keys(validationErrors).forEach(fieldName => {
            formikRef.current.setFieldTouched(fieldName, true, false);
          });
        }
        
        // Exibir mensagem detalhada com todos os campos que precisam ser preenchidos
        const errorList = errorMessages.join('\n');
        alert.error(
          `Por favor, preencha os seguintes campos obrigatórios:\n\n${errorList}`,
          { timeout: 15000 }
        );
        
        // Também rolar para o primeiro erro
        const firstErrorField = Object.keys(validationErrors)[0];
        if (firstErrorField) {
          setTimeout(() => {
            // Tentar encontrar o campo pelo name
            let errorElement = document.querySelector(`[name="${firstErrorField}"]`);
            
            // Se não encontrar, tentar encontrar pelo id
            if (!errorElement) {
              errorElement = document.getElementById(firstErrorField);
            }
            
            // Se ainda não encontrar, tentar encontrar pelo label ou placeholder
            if (!errorElement) {
              const labels = document.querySelectorAll('label');
              labels.forEach(label => {
                if (label.textContent.toLowerCase().includes(fieldNames[firstErrorField]?.toLowerCase() || firstErrorField)) {
                  const input = label.querySelector('input, textarea, select');
                  if (input) {
                    errorElement = input;
                  }
                }
              });
            }
            
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              errorElement.focus();
              // Destacar o campo com erro
              errorElement.style.borderColor = '#f44336';
              setTimeout(() => {
                errorElement.style.borderColor = '';
              }, 3000);
            }
          }, 200);
        }
      });
  };

  const convocationExecutedRef = useRef(false);
  
  useEffect(() => {
    if (
      convocationActive &&
      convocationActive.id &&
      formikRef.current?.values?.cte_type === 'embarcador' &&
      confirm &&
      !convocationExecutedRef.current
    ) {
      convocationExecutedRef.current = true;
      cteConvocation(formikRef.current.values.invoices);
    }
    // Resetar quando confirm mudar para false
    if (!confirm) {
      convocationExecutedRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convocationActive?.id, confirm]);

  // useEffect para inicializar cte_type e invoices
  useEffect(() => {
    if (!formikRef.current) return;
    
    if (cte && edit && !cteTypeInitializedRef.current) {
      if (formikRef.current.values.cte_type !== 'embarcador') {
        formikRef.current.setFieldValue('cte_type', 'embarcador', false);
        cteTypeInitializedRef.current = true;
      }

      if (cte.invoices && !invoicesInitializedRef.current) {
        let invoices = [];
        cte.invoices.forEach((item) => {
          invoices.push({
            ...item,
            cnpj: item?.cpf || item.cnpj,
            volume: parseFloat(item?.volume),
            weight: parseFloat(item?.weight),
          });
        });
        formikRef.current.setFieldValue('invoices', invoices, false);
        invoicesInitializedRef.current = true;
      }

      if (convocationId?.type_convocation) {
        setConvocationType(convocationId.type_convocation);
      }
    } else if (!edit && !cteTypeInitializedRef.current) {
      if (formikRef.current.values.cte_type !== 'motorista') {
        formikRef.current.setFieldValue('cte_type', 'motorista', false);
        cteTypeInitializedRef.current = true;
      }
      if (!formikRef.current.values.invoices || formikRef.current.values.invoices.length > 0) {
        if (!invoicesInitializedRef.current) {
          formikRef.current.setFieldValue('invoices', [], false);
          invoicesInitializedRef.current = true;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cte?.id, edit]);

  // useEffect para trucker
  useEffect(() => {
    if (!formikRef.current) return;
    
    if (oneTrucker?.id && !truckerInitializedRef.current) {
      if (formikRef.current.values.private_trucker_cpf !== oneTrucker.cpf) {
        formikRef.current.setFieldValue('private_trucker_cpf', oneTrucker.cpf, false);
      }
      if (formikRef.current.values.private_trucker !== oneTrucker.name) {
        formikRef.current.setFieldValue('private_trucker', oneTrucker.name, false);
      }
      truckerInitializedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oneTrucker?.id]);

  async function handleSubmitted(values) {
    
    const errors = validateRequester(values.owner);

    // Nota: As notas fiscais (invoices) estão nas viagens, não na carga
    // Removida validação de invoices na carga, pois as notas são das viagens relacionadas

    // Validar pelo menos 1 viagem selecionada
    if (!values.delivery_viagens || values.delivery_viagens.length === 0) {
      errors.delivery_viagens = 'Selecione pelo menos 1 viagem';
      if (formikRef.current) {
        formikRef.current.setFieldError('delivery_viagens', errors.delivery_viagens);
        formikRef.current.setFieldTouched('delivery_viagens', true, false);
      }
    }

    // Validação de tomador (cliente) removida na tela de carga.
    // A validação fica apenas na tela de viagem, conforme solicitado.

    // Validar se motorista está cadastrado como fornecedor
    if (values.condutores && values.condutores.length > 0) {
      for (const condutor of values.condutores) {
        if (condutor.cpf) {
          try {
            const cpfLimpo = condutor.cpf.replace(/\D/g, '');
            const fornecedores = await fornecedoresAPI.listar({ cpfCnpj: cpfLimpo });
            if (!fornecedores || fornecedores.length === 0) {
              alert.error(`O motorista ${condutor.nome || condutor.cpf} não está cadastrado como fornecedor. Por favor, cadastre-o primeiro.`);
              return;
            }
          } catch (error) {
            console.error('Erro ao validar motorista:', error);
            alert.error('Erro ao validar motorista. Tente novamente.');
            return;
          }
        }
      }
    }

    if (Object.keys(errors).length === 0) {
      // logs de debug removidos
      
      // Obter empresa selecionada do localStorage
      let empresaId = null;
      try {
        const selectedCompany = JSON.parse(localStorage.getItem('selectedCompany') || 'null');
        empresaId = selectedCompany?.id || null;
      } catch (error) {
        console.error('Erro ao obter empresa selecionada:', error);
      }
      
      const data_values = {
        cnpj: values.cnpj,
        owner: values.owner,
        owner_email: values.owner_email,
        provider_id: values.provider_id || null, // Converter string vazia para null
        type: values.cargo_type,
        validity: values.validity,
        value: values.value,
        freight_value: values.freight_value,
        quantity_delivery: values.invoices.length,
        type_convocation: values.type_convocation,
        type_insurance: values.type_insurance,
        insurance_value: values.insurance_value,
        selected_insurance_id: values.selected_insurance_id || null, // Converter string vazia para null
        insurance_codigo: values.insurance_codigo,
        insurance_nome_seguradora: values.insurance_nome_seguradora,
        insurance_cnpj_seguradora: values.insurance_cnpj_seguradora,
        insurance_numero_apolice: values.insurance_numero_apolice,
        insurance_responsavel: values.insurance_responsavel,
        insurance_cpf_cnpj_contratante: values.insurance_cpf_cnpj_contratante,
        toll_value: values.toll_value,
        note: values.note,
        // Campos CT-e e MDF-e
        natureza_operacao: values.natureza_operacao,
        cfop: values.cfop,
        tipo_servico: values.tipo_servico,
        modal: values.modal,
        tipo_cte: values.tipo_cte,
        uf_inicio: values.uf_inicio,
        uf_fim: values.uf_fim,
        data_inicio_viagem: values.data_inicio_viagem,
        codigo_municipio_carregamento: values.codigo_municipio_carregamento,
        nome_municipio_carregamento: values.nome_municipio_carregamento,
        uf_carregamento: values.uf_carregamento,
        codigo_municipio_descarregamento: values.codigo_municipio_descarregamento,
        nome_municipio_descarregamento: values.nome_municipio_descarregamento,
        uf_descarregamento: values.uf_descarregamento,
        outras_caracteristicas: values.outras_caracteristicas,
        informacoes_fisco: values.informacoes_fisco,
        informacoes_complementares: values.informacoes_complementares,
        municipios_carga: values.municipios_carga || [],
        ufs_percurso: values.ufs_percurso || [],
        ufs_carga: values.ufs_carga || [],
        // Campos Produto Predominante
        tipo_carga: values.tipo_carga,
        descricao_produto: values.descricao_produto,
        gtin: values.gtin,
        ncm: values.ncm,
        // Campos Rodoviário
        rntrc: values.rntrc,
        ciot: values.ciot,
        veiculos: values.veiculos || [],
        condutores: values.condutores || [],
        // Campos Totais
        quantidade_cte: values.quantidade_cte || 0,
        quantidade_nfe: values.quantidade_nfe || 0,
        quantidade_mdfe: values.quantidade_mdfe || 0,
        valor_carga: values.valor_carga || 0,
        peso_bruto: values.peso_bruto || 0,
        peso_liquido: values.peso_liquido || 0,
        adiantamento_motorista: values.adiantamento_motorista || 0,
        natureza_adiantamento_id: values.naturezaAdiantamentoId || null,
        natureza_frete_id: values.naturezaFreteId || null,
        // Viagens relacionadas (serão vinculadas após criar a carga)
        delivery_viagens: values.delivery_viagens || [],
      };

      if (values.delivery_cpf) {
        data_values.delivery_cpf = values.delivery_cpf;
      }
      
      if (values.delivery_cnpj) {
        data_values.delivery_cnpj = values.delivery_cnpj;
      }

      if (values.private_trucker_cpf) {
        data_values.driver = values.private_trucker_cpf;
        data_values.driver_name = values.private_trucker;
      }

      if (edit) {
        data_values.id = convocationId.id;
        data_values.created_at = convocationId.created_at;
      }
      
      // Adicionar empresa_id se houver empresa selecionada
      if (empresaId) {
        data_values.empresa_id = empresaId;
      }

      // logs de debug removidos
      // Remover modal de resumo - salvar diretamente
      addConvocation(data_values);
    } else {
      console.error('❌ [CreateConvocation] Erros de validação impedem o salvamento:', errors);
      // Exibir erros no formulário
      if (formikRef.current) {
        Object.keys(errors).forEach(key => {
          formikRef.current.setFieldError(key, errors[key]);
        });
      }
    }
  }

  const validateRequester = (value) => {
    const errors = {};
    if (!value || value === '') {
      errors.providerId = 'Obrigatório, escolha um solicitante.';
    }

    return errors;
  };

  const cteConvocation = (invoices) => {
    if (!convocationActive || !convocationActive.id) {
      console.error('❌ [cteConvocation] convocationActive não está disponível');
      return;
    }
    
    let totalInvoices = 0;
    // Converter freight_value para string e tratar diferentes formatos
    const freightValueStr = String(convocationActive.freight_value || '0');
    // Se começar com "R$", remover os primeiros 3 caracteres, senão usar o valor completo
    const freightValueClean = freightValueStr.startsWith('R$') 
      ? freightValueStr.substring(3).trim()
      : freightValueStr.trim();
    // Remover pontos de milhar e substituir vírgula por ponto
    const freightValueFormatted = freightValueClean.replace(/\./g, '').replace(',', '.');
    let transportTotal = parseFloat(freightValueFormatted) || 0;
    let balance = transportTotal;
    let weightTotal = 0;

    //Faz o calculo para rateio do frete
    invoices.forEach((item) => {
      totalInvoices += item.nfeValue;
      weightTotal += parseFloat(item.weight);
    });

    const data_cte = {
      convocation_id: convocationActive?.id || null,
      totalInvoices: totalInvoices,
      transportTotal: transportTotal,
      typeCte: 'convocation',
      weightTotal: weightTotal,
      send_tax: parseFloat((transportTotal * 0.0175).toFixed(2)),
      tax: parseFloat((transportTotal * 0.085).toFixed(2)),
      invoices: [],
    };

    invoices.forEach((item, index) => {
      let participation = item.nfeValue / totalInvoices;
      let transportValue = 0;

      if (index === invoices.length - 1) {
        transportValue = Number(balance.toFixed(2));
      } else {
        transportValue = Number((transportTotal * participation).toFixed(2));

        if (balance < transportValue) {
          transportValue = Number(balance.toFixed(2));
        }
      }

      balance -= transportValue;

      data_cte.invoices.push({
        barcode: item.barcode,
        nfeValue: item.nfeValue,
        volume: item.volume,
        weight: item.weight,
        transportValue: parseFloat(transportValue),
        payment_responser: item.payment_responser,
      });

      //valido se é destinatario é pessoa fisica ou juridica
      if (item.hasOwnProperty('receiver')) {
        data_cte.invoices[index].cpf = item.cnpj;
        data_cte.invoices[index].receiver = item.receiver;
      } else {
        data_cte.invoices[index].cnpj = item.cnpj;
      }
    });

    if (data_cte && !edit) {
      dispatch(CtesActions.addCteRequest(data_cte, closeModal));
    } else if (data_cte && edit && cte && cte.id) {
      dispatch(
        CtesActions.updateCteRequest({ ...data_cte, id: cte.id }, closeModal)
      );
    } else if (data_cte && edit && (!cte || !cte.id)) {
      console.error('❌ [cteConvocation] Não é possível atualizar CT-e: cte ou cte.id não está disponível');
    }
  };

  const closeModal = () => {
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    history.push({
      pathname: '/cargas',
    });
  };

  const addConvocation = (dataToSave) => {
    // logs de debug removidos
    
    // Calcular freight para validação
    const freight_value_str = dataToSave?.freight_value 
      ? String(dataToSave.freight_value).replace('R$', '').replace(/\./g, '').replace(',', '.')
      : '0';
    const freight_value = parseFloat(freight_value_str) || 0;
    
    const value_str = dataToSave?.value 
      ? String(dataToSave.value).replace('R$', '').replace(/\./g, '').replace(',', '.')
      : '0';
    const value_num = parseFloat(value_str) || 0;
    
    const insurance_value = dataToSave?.insurance_value
      ? parseFloat(String(dataToSave.insurance_value).replace(/\./g, '').replace(',', '.')) || 0
      : 0;
    
    const toll_value = dataToSave?.toll_value
      ? parseFloat(String(dataToSave.toll_value).replace(/\./g, '').replace(',', '.')) || 0
      : 0;
    
    const unload_value = dataToSave?.unload_value
      ? parseFloat(String(dataToSave.unload_value).replace(/\./g, '').replace(',', '.')) || 0
      : 0;
    
    const risk_rate = 36.25;
    
    if (!dataToSave?.owner) {
      console.error('❌ [CreateConvocation] Owner não informado');
      alert.error('Por favor, informe o solicitante');
      return;
    }

    // logs de debug removidos
    if (edit) {
      dispatch(
        ConvocationsActions.updateConvocationRequest(dataToSave, closeModal)
      );
      setConfirm(true);
    } else {
      dispatch(ConvocationsActions.addConvocationRequest(dataToSave, closeModal));
      setConfirm(true);
    }
  };

  const getTruckerId = (cpf) => {
    if (cpf.length === 14) dispatch(TruckerActions.getCpfTruckerRequest(cpf));
  };

  // Este useEffect será movido para dentro do render do Formik

  const truckersOptions = [];

  truckers.map((item) =>
    truckersOptions.push({
      value: item.id,
      label: item.name,
      name: item.name,
      cpf: item.cpf,
    })
  );

  return (
    <>
      <Paper
        title={provider ? 'ALTERAR CARGA' : 'INCLUIR CARGA'}
        icon={Images.IconGrayUser}
      />
      <Header>Nova carga</Header>
      <Container>
        <Formik
          innerRef={formikRef}
          initialValues={getInitialValues()}
          onSubmit={handleSubmit}
          validationSchema={schema}
          enableReinitialize
        >
          {({ values, handleChange: formikHandleChange, handleSubmit: formikHandleSubmit, errors, touched, setFieldValue, setFieldError, setFieldTouched }) => {
            return (
              <form onSubmit={formikHandleSubmit} id="convocation-form">
          <WrapperButtons>
            <Button
              type="button"
              label="Cancelar"
              width="130px"
              height="33px"
              onClick={() => history.goBack()}
            />
            {!view && (
              <Button
                type="button"
                label="Salvar"
                width="130px"
                height="33px"
                margin="20px"
                onClick={() => {
                  if (formikRef.current) {
                    formikRef.current.handleSubmit();
                  }
                }}
              />
            )}
          </WrapperButtons>

          <WrapperNav>
            <TabNav value={headerId} onChange={handleChange}>
              <TabItem value={0} label="DADOS DO MDF-E" />
              <TabItem value={1} label="DADOS DO SOLICITANTE" />
              <TabItem value={2} label="LOCAIS DE ENTREGA" />
              <TabItem value={3} label="DADOS SEGURO" />
              <TabItem value={4} label="RODOVIÁRIO" />
              <TabItem value={5} label="PRODUTO PREDOMINANTE" />
              <TabItem value={6} label="TOTAIS" />
            </TabNav>
          </WrapperNav>
          {headerId === 0 ? (
            <>
              <WrapperSection>
                <LoadInfo
                  edit={edit}
                  view={view}
                  formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }}
                  setConvocationType={setConvocationType}
                />
              </WrapperSection>

              {convocationType === 'private' ? (
                <Section title="MOTORISTA">
                  <WrapperSection>
                    <WrapperInput>
                      <MaskedInput
                        mask="999.999.999-99"
                        value={values.private_trucker_cpf}
                        onChange={formikHandleChange}
                        onBlur={(e) => {
                          getTruckerId(e.target.value);
                        }}
                        disabled={edit}
                      >
                        {(inputProps) => (
                          <TextField
                            {...inputProps}
                            label="CPF"
                            error={
                              touched.private_trucker_cpf &&
                              Boolean(errors.private_trucker_cpf)
                            }
                            helperText={touched.private_trucker_cpf && errors.private_trucker_cpf}
                            fullWidth
                            color="secondary"
                          />
                        )}
                      </MaskedInput>
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Nome"
                        name="private_trucker"
                        placeholder=""
                        disabled
                        value={values.private_trucker}
                        onChange={formikHandleChange}
                        fullWidth
                        color="secondary"
                      />
                    </WrapperInput>
                  </WrapperSection>
                </Section>
              ) : null}

              <CteMdfe formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
              <MunicipiosCarga formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
          {headerId === 1 ? (
              <ProviderData
              formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }}
              edit={edit}
              view={view}
            />
          ) : null}
          {headerId === 2 ? (
            <>
              <DeliveryPoint formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
          {headerId === 3 ? (
            <>
              <Insurance formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
          {headerId === 4 ? (
            <>
              <Rodoviario formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
          {headerId === 5 ? (
            <>
              <ProdutoPredominante formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
          {headerId === 6 ? (
            <>
              <Totais formik={{ values, handleChange: formikHandleChange, setFieldValue, setFieldError, setFieldTouched, errors, touched }} edit={edit} view={view} />
            </>
          ) : null}
              </form>
            );
          }}
        </Formik>
      </Container>
      
      {/* Modal de tomador removido na tela de carga (validação ficará apenas em viagem). */}
    </>
  );
}

export default PublicConvocation;
